function sourceUrl(value) {
  try {
    const url = new URL(value);
    return ["https:", "http:"].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
}

export default function SearchGrounding({ citations = [], suggestions }) {
  const sources = citations.flatMap((citation) => {
    const url = sourceUrl(citation.url);
    return url ? [{ ...citation, url }] : [];
  });

  return (
    <>
      {sources.length > 0 && (
        <nav aria-label="Fontes consultadas">
          <ul>
            {sources.map((source, index) => (
              <li key={`${source.url}-${index}`}>
                <a href={source.url} target="_blank" rel="noopener noreferrer">
                  {source.title || source.url}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      )}
      {suggestions && (
        <iframe
          title="Sugestões de pesquisa do Google"
          className="trunfo-chat__search-suggestions"
          sandbox="allow-popups allow-popups-to-escape-sandbox"
          srcDoc={suggestions}
        />
      )}
    </>
  );
}
